import { MessageCircle } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const LOGO_URL = "/assets/images/logo.png";
const WHATSAPP_NUMBER = "+41779938989";

const navLinks = [
  { href: '#start', label: 'Start' },
  { href: '#leistungen', label: 'Leistungen' },
  { href: '#ueber-uns', label: 'Über uns' },
  { href: '#faq', label: 'FAQ' },
];

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (e, href) => {
    e.preventDefault();
    if (location.pathname === '/') {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const openWhatsApp = () => {
    const message = encodeURIComponent("Guten Tag, ich interessiere mich für Ihre Sicherheitsdienstleistungen.");
    window.open(`https://wa.me/${WHATSAPP_NUMBER.replace(/\+/g, '')}?text=${message}`, '_blank');
  };

  return (
    <footer className="bg-[#0B0F19] border-t border-[#1E293B]" data-testid="footer">
      <div className="container-custom py-12 md:py-16">
        <div className="grid md:grid-cols-3 gap-10 md:gap-8">
          {/* Logo & Description */}
          <div>
            <img
              src={LOGO_URL}
              alt="Praesidium Protection"
              className="h-12 w-auto mb-4"
            />
            <p className="text-[#94A3B8] text-sm leading-relaxed mb-4">
              Premium-Sicherheitsdienstleistungen in der Schweiz und weltweit.
              Diskretion, Professionalität und Vertrauen.
            </p>
            <button
              onClick={openWhatsApp}
              className="inline-flex items-center gap-2 text-[#D4AF37] text-sm hover:text-[#E5C55D] transition-colors"
              data-testid="footer-whatsapp"
            >
              <MessageCircle size={18} />
              +41 77 993 89 89
            </button>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-[#F1F5F9] font-semibold mb-4 font-['DM_Sans'] text-lg">
              Navigation
            </h4>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-[#94A3B8] text-sm hover:text-[#D4AF37] transition-colors"
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#1E293B] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#64748B] text-xs">
            © {currentYear} Praesidium Protection. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-6">
            <Link to="/impressum" className="text-[#64748B] text-xs hover:text-[#94A3B8] transition-colors">
              Impressum
            </Link>
            <Link to="/datenschutz" className="text-[#64748B] text-xs hover:text-[#94A3B8] transition-colors">
              Datenschutz
            </Link>
            <Link to="/agb" className="text-[#64748B] text-xs hover:text-[#94A3B8] transition-colors">
              AGB
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
